import H3 from './H3';
import theme from '../theme';
import fn from '../../helpers/fn';

const SubTitle = H3.withComponent('div');

export default fn(__filename, SubTitle.extend`
  color: ${props => (props.white ? theme.colors.white : theme.colors.gray1)};
  margin-bottom: ${theme.unit * 2}px;
  text-align:center;

  ${({ alignLeft }) => alignLeft && `
    @media screen and (min-width: ${alignLeft}) {
      text-align: left;
    }
  `}
`);



// WEBPACK FOOTER //
// ./src/components/headings/SubTitle.js